import React from 'react';
import ReactEcharts from 'echarts-for-react';
import InvestCircleChartSC, {
  ChartTopSC,
  ChartBottomSC,
  ChartWrapSC,
  DataWrapSC,
  ChartInsideStatsSC,
  BackButtonSC,
  GraphToggleButton,
} from './invest-circle-chart.styled';
import { BodyText, SmallText, HeadingFour, HeadingThree } from '../../typography';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import numeral from 'numeral';
import { ReactComponent as TooltipIcon } from '../../../assets/img/svg/tip.svg';

class InvestCircleChart extends React.Component {
  state = {
    selectedType: '',
    data: [
      { value: 0, name: 'paid' },
      { value: 0, name: 'medium-delay' },
      { value: 0, name: 'high-delay' },
    ],
    totals: {
      count: 0,
      total_amount: 0,
      delayed_amount: 0,
    },
    stats: [
      { count: 0, total: 0, paid: 0, delayed: 0, tillEnd: 0 },
      { count: 0, total: 0, paid: 0, delayed: 0, tillEnd: 0 },
      { count: 0, total: 0, paid: 0, delayed: 0, tillEnd: 0 },
    ],
    colors: ['#09BA50', '#83828F', '#F71D1D'],
    tooltipPaidIsShown: false,
    tooltipMediumIsShown: false,
    tooltipHighIsShown: false,
  };

  componentDidMount() {
    if (this.props.chartData !== null) {
      this.setState({ data: this.props.chartData });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.chartData !== this.props.chartData) {
      this.setState({ data: this.props.chartData });
    }
    if (prevProps.totals !== this.props.totals) {
      this.setState({ totals: this.props.totals });
    }
    if (prevProps.stats !== this.props.stats) {
      this.setState({ stats: this.props.stats });
    }
  }

  onChartClick = (e) => {
    let formattedName = e.name;
    let newData = this.state.data.find((name) => name.name === e.name);
    if (formattedName === this.state.selectedType) {
      this.setState({
        selectedType: '',
        data: this.props.chartData,
        colors: ['#09BA50', '#83828F', '#F71D1D'],
        tooltipPaidIsShown: false,
        tooltipMediumIsShown: false,
        tooltipHighIsShown: false,
      });
      this.setState({});
    } else {
      this.setState({
        selectedType: formattedName,
        data: [newData],
        colors: [e.name === 'paid' ? '#09BA50' : e.name === 'medium-delay' ? '#83828F' : '#F71D1D'],
        tooltipPaidIsShown: false,
        tooltipMediumIsShown: false,
        tooltipHighIsShown: false,
      });
    }
  };

  toggleGraphModes = () => {
    this.props.graphMode === 'percentage'
      ? this.props.setMode('count')
      : this.props.setMode('percentage');
  };

  backFromDetail = () => {
    this.setState({
      selectedType: '',
      data: this.props.chartData,
      colors: ['#09BA50', '#83828F', '#F71D1D'],
    });
  };

  renderRightTranslation = (val) => {
    let resultText = '';

    if (
      val === 1 &&
      (this.state.tooltipPaidIsShown ||
        this.state.tooltipMediumIsShown ||
        this.state.tooltipHighIsShown)
    ) {
      resultText = (
        <FormattedHTMLMessage
          id="investor_dash_banner_circle_chart_middle_investment_single_tooltip"
          defaultMessage={dlt['investor_dash_banner_circle_chart_middle_investment_single_tooltip']}
        />
      );
    } else if (val === 1) {
      resultText = (
        <FormattedHTMLMessage
          id="investor_dash_banner_circle_chart_middle_investment_single"
          defaultMessage={dlt['investor_dash_banner_circle_chart_middle_investment_single']}
        />
      );
    } else if (
      val > 1 &&
      val < 5 &&
      (this.state.tooltipPaidIsShown ||
        this.state.tooltipMediumIsShown ||
        this.state.tooltipHighIsShown)
    ) {
      resultText = (
        <FormattedHTMLMessage
          id="investor_dash_banner_circle_chart_middle_investment_few_tooltip"
          defaultMessage={dlt['investor_dash_banner_circle_chart_middle_investment_few_tooltip']}
        />
      );
    } else if (val > 1 && val < 5) {
      resultText = (
        <FormattedHTMLMessage
          id="investor_dash_banner_circle_chart_middle_investment_few"
          defaultMessage={dlt['investor_dash_banner_circle_chart_middle_investment_few']}
        />
      );
    } else if (
      val >= 5 &&
      (this.state.tooltipPaidIsShown ||
        this.state.tooltipMediumIsShown ||
        this.state.tooltipHighIsShown)
    ) {
      resultText = (
        <FormattedHTMLMessage
          id="investor_dash_banner_circle_chart_middle_investment_many_tooltip"
          defaultMessage={dlt['investor_dash_banner_circle_chart_middle_investment_many_tooltip']}
        />
      );
    } else {
      resultText = (
        <FormattedHTMLMessage
          id="investor_dash_banner_circle_chart_middle_investment_many"
          defaultMessage={dlt['investor_dash_banner_circle_chart_middle_investment_many']}
        />
      );
    }

    return resultText;
  };

  getOption() {
    return {
      color: this.state.colors,
      series: [
        {
          type: 'pie',
          startAngle: -180,
          radius: this.props.isMobile
            ? this.state.selectedType === ''
              ? ['86%', '97%']
              : ['90%', '97%']
            : this.state.selectedType === ''
            ? ['89%', '97%']
            : ['92%', '97%'],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          selectedOffset: this.state.selectedType === '' ? 3 : 0,
          selectedMode: false,
          itemStyle: {
            borderColor: '#2f2e41',
            borderWidth: this.state.selectedType === '' ? 3 : 0,
          },
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          data: this.state.data,
        },
      ],
    };
  }

  render() {
    return (
      <InvestCircleChartSC>
        <ChartTopSC>
          <BodyText className="grey bolder">
            <FormattedMessage
              id="investor_dash_banner_circle_chart_top"
              defaultMessage={dlt['investor_dash_banner_circle_chart_top']}
            />
          </BodyText>
        </ChartTopSC>

        <ChartBottomSC>
          <ChartWrapSC>
            <ChartInsideStatsSC selected={this.state.selectedType}>
              <div className="all-stats">
                {this.state.selectedType === 'paid' ? (
                  <>
                    <HeadingThree className="green">
                      {this.props.graphMode === 'percentage'
                        ? `${numeral(Number(this.state.stats[0].count)).format('0,00.00')} %`
                        : `${this.state.stats[0].count}`}
                    </HeadingThree>

                    <div className="separator-detail" />
                    <SmallText className="smaller dark-grey">
                      {this.renderRightTranslation(this.state.stats[0].count)}
                      <br />
                      {this.state.stats[0].count === 1 ? (
                        <FormattedHTMLMessage
                          id="investor_dash_banner_circle_chart_middle_paid_single"
                          defaultMessage={
                            dlt['investor_dash_banner_circle_chart_middle_paid_single']
                          }
                        />
                      ) : this.state.stats[0].count > 1 && this.state.stats[0].count < 5 ? (
                        <FormattedHTMLMessage
                          id="investor_dash_banner_circle_chart_middle_paid_multiple"
                          defaultMessage={
                            dlt['investor_dash_banner_circle_chart_middle_paid_multiple']
                          }
                        />
                      ) : (
                        <FormattedHTMLMessage
                          id="investor_dash_banner_circle_chart_middle_paid"
                          defaultMessage={dlt['investor_dash_banner_circle_chart_middle_paid']}
                        />
                      )}
                    </SmallText>
                    <BackButtonSC onClick={this.backFromDetail}>
                      <FormattedMessage id="global_back" defaultMessage={dlt['global_back']} />
                    </BackButtonSC>
                  </>
                ) : this.state.selectedType === 'medium-delay' ? (
                  <>
                    <HeadingThree className="chart-grey">
                      {this.props.graphMode === 'percentage'
                        ? `${numeral(Number(this.state.stats[1].count)).format('0,00.00')} %`
                        : `${this.state.stats[1].count}`}
                    </HeadingThree>
                    <div className="separator-detail" />
                    <SmallText className="smaller dark-grey">
                      {this.renderRightTranslation(this.state.stats[1].count)}
                      <br />
                      <FormattedHTMLMessage
                        id="investor_dash_banner_circle_chart_middle_medium"
                        defaultMessage={dlt['investor_dash_banner_circle_chart_middle_medium']}
                      />
                    </SmallText>
                    <BackButtonSC onClick={this.backFromDetail}>
                      <FormattedMessage id="global_back" defaultMessage={dlt['global_back']} />
                    </BackButtonSC>
                  </>
                ) : this.state.selectedType === 'high-delay' ? (
                  <>
                    <HeadingThree className="red">
                      {this.props.graphMode === 'percentage'
                        ? `${numeral(Number(this.state.stats[2].count)).format('0,00.00')} %`
                        : `${this.state.stats[2].count}`}
                    </HeadingThree>
                    <div className="separator-detail" />
                    <SmallText className="smaller dark-grey">
                      {this.renderRightTranslation(this.state.stats[2].count)}
                      <br />
                      <FormattedHTMLMessage
                        id="investor_dash_banner_circle_chart_middle_high"
                        defaultMessage={dlt['investor_dash_banner_circle_chart_middle_high']}
                      />
                    </SmallText>
                    <BackButtonSC onClick={this.backFromDetail}>
                      <FormattedMessage id="global_back" defaultMessage={dlt['global_back']} />
                    </BackButtonSC>
                  </>
                ) : (
                  <>
                    <HeadingFour className="green">
                      <span
                        onClick={() => this.onChartClick({ name: 'paid' })}
                        onMouseEnter={() =>
                          this.setState({
                            tooltipPaidIsShown: true,
                            data: [
                              { ...this.state.data[0], selected: true },
                              { ...this.state.data[1], selected: false },
                              { ...this.state.data[2], selected: false },
                            ],
                          })
                        }
                        onMouseLeave={() =>
                          this.setState({
                            tooltipPaidIsShown: false,
                            data: [
                              { ...this.state.data[0], selected: false },
                              { ...this.state.data[1], selected: false },
                              { ...this.state.data[2], selected: false },
                            ],
                          })
                        }
                      >
                        {this.state.tooltipPaidIsShown === true ? (
                          <div className="tooltip">
                            <TooltipIcon />
                            <div>
                              {`${
                                this.props.graphMode === 'percentage'
                                  ? `${numeral(Number(this.state.stats[0].count)).format(
                                      '0,00.00'
                                    )} % `
                                  : `${this.state.stats[0].count} `
                              }`}
                              {this.renderRightTranslation(this.state.stats[0].count)}{' '}
                              {numeral(this.state.stats[0].total).format('0,00.00')} €
                            </div>
                          </div>
                        ) : null}
                        {this.props.graphMode === 'percentage'
                          ? `${numeral(Number(this.state.stats[0].count)).format('0,00.00')} %`
                          : `${this.state.stats[0].count}`}
                      </span>
                    </HeadingFour>

                    <div className="separator" />
                    <HeadingFour className="chart-grey">
                      <span
                        onClick={() => this.onChartClick({ name: 'medium-delay' })}
                        onMouseEnter={() =>
                          this.setState({
                            tooltipMediumIsShown: true,
                            data: [
                              { ...this.state.data[0], selected: false },
                              { ...this.state.data[1], selected: true },
                              { ...this.state.data[2], selected: false },
                            ],
                          })
                        }
                        onMouseLeave={() =>
                          this.setState({
                            tooltipMediumIsShown: false,
                            data: [
                              { ...this.state.data[0], selected: false },
                              { ...this.state.data[1], selected: false },
                              { ...this.state.data[2], selected: false },
                            ],
                          })
                        }
                      >
                        {this.state.tooltipMediumIsShown === true ? (
                          <div className="tooltip">
                            <TooltipIcon />
                            <div>
                              {`${
                                this.props.graphMode === 'percentage'
                                  ? `${numeral(Number(this.state.stats[1].count)).format(
                                      '0,00.00'
                                    )} % `
                                  : `${this.state.stats[1].count} `
                              }`}
                              {this.renderRightTranslation(this.state.stats[1].count)}{' '}
                              {numeral(this.state.stats[1].total).format('0,00.00')} €
                            </div>
                          </div>
                        ) : null}
                        {this.props.graphMode === 'percentage'
                          ? `${numeral(Number(this.state.stats[1].count)).format('0,00.00')} %`
                          : `${this.state.stats[1].count}`}
                      </span>
                    </HeadingFour>
                    <div className="separator" />
                    <HeadingFour className="red">
                      <span
                        onClick={() => this.onChartClick({ name: 'high-delay' })}
                        onMouseEnter={() =>
                          this.setState({
                            tooltipHighIsShown: true,
                            data: [
                              { ...this.state.data[0], selected: false },
                              { ...this.state.data[1], selected: false },
                              { ...this.state.data[2], selected: true },
                            ],
                          })
                        }
                        onMouseLeave={() =>
                          this.setState({
                            tooltipHighIsShown: false,
                            data: [
                              { ...this.state.data[0], selected: false },
                              { ...this.state.data[1], selected: false },
                              { ...this.state.data[2], selected: false },
                            ],
                          })
                        }
                      >
                        {this.state.tooltipHighIsShown === true ? (
                          <div className="tooltip">
                            <TooltipIcon />
                            <div>
                              {`${
                                this.props.graphMode === 'percentage'
                                  ? `${numeral(Number(this.state.stats[2].count)).format(
                                      '0,00.00'
                                    )} % `
                                  : `${this.state.stats[2].count} `
                              }`}
                              {this.renderRightTranslation(this.state.stats[2].count)}{' '}
                              {numeral(this.state.stats[2].total).format('0,00.00')} €
                            </div>
                          </div>
                        ) : null}
                        {this.props.graphMode === 'percentage'
                          ? `${numeral(Number(this.state.stats[2].count)).format('0,00.00')} %`
                          : `${this.state.stats[2].count}`}
                      </span>
                    </HeadingFour>
                  </>
                )}
              </div>
            </ChartInsideStatsSC>
            <ReactEcharts
              option={this.getOption()}
              style={{ height: '100%', width: '100%' }}
              onEvents={{ click: this.onChartClick }}
            />
            {this.state.selectedType === '' && (
              <GraphToggleButton
                className={this.props.graphMode === 'percentage' ? 'active' : ''}
                onClick={this.toggleGraphModes}
              >
                <span>%</span>
              </GraphToggleButton>
            )}
          </ChartWrapSC>
          {this.state.selectedType === '' ? (
            <DataWrapSC>
              <div className="row">
                <div className="col">
                  <SmallText className="dark-grey bolder">
                    <FormattedMessage
                      id="investor_dash_banner_circle_chart_count_of_loans"
                      defaultMessage={dlt['investor_dash_banner_circle_chart_count_of_loans']}
                    />
                  </SmallText>
                  <HeadingThree className="white">{this.state.totals.count}</HeadingThree>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <SmallText className="dark-grey bolder">
                    <FormattedMessage
                      id="investor_dash_banner_circle_chart_invested_in_loans"
                      defaultMessage={dlt['investor_dash_banner_circle_chart_invested_in_loans']}
                    />
                  </SmallText>
                  <HeadingFour className="white">
                    {numeral(this.state.totals.total_amount).format('0,00.00')} €
                  </HeadingFour>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <SmallText className="dark-grey bolder">
                    <FormattedMessage
                      id="investor_dash_banner_circle_chart_in_arrears"
                      defaultMessage={dlt['investor_dash_banner_circle_chart_in_arrears']}
                    />
                  </SmallText>
                  <HeadingFour className="white">
                    {numeral(this.state.totals.delayed_amount).format('0,00.00')} €
                  </HeadingFour>
                </div>
              </div>
            </DataWrapSC>
          ) : this.state.selectedType === 'paid' ? (
            <DataWrapSC>
              <div className="row">
                <div className="col">
                  <SmallText className="dark-grey bolder">
                    <FormattedMessage
                      id="investor_dash_banner_circle_chart_value_total"
                      defaultMessage={dlt['investor_dash_banner_circle_chart_value_total']}
                    />
                  </SmallText>
                  <HeadingThree className="white">
                    {' '}
                    {numeral(this.state.stats[0].total).format('0,00.00')} €
                  </HeadingThree>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <SmallText className="green bolder">
                    <FormattedMessage
                      id="investor_dash_banner_circle_chart_waits_paid"
                      defaultMessage={dlt['investor_dash_banner_circle_chart_waits_paid']}
                    />
                  </SmallText>
                  <HeadingFour className="green">
                    {numeral(this.state.stats[0].paid).format('0,00.00')} €
                  </HeadingFour>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <SmallText className="white bolder">
                    <FormattedMessage
                      id="investor_dash_banner_circle_chart_waits_till_end"
                      defaultMessage={dlt['investor_dash_banner_circle_chart_waits_till_end']}
                    />
                  </SmallText>
                  <HeadingFour className="white">
                    {numeral(this.state.stats[0].tillEnd).format('0,00.00')} €
                  </HeadingFour>
                </div>
              </div>
            </DataWrapSC>
          ) : this.state.selectedType === 'medium-delay' ? (
            <DataWrapSC>
              <div className="row smaller-padding">
                <div className="col">
                  <SmallText className="dark-grey bolder">
                    {' '}
                    <FormattedMessage
                      id="investor_dash_banner_circle_chart_value_total"
                      defaultMessage={dlt['investor_dash_banner_circle_chart_value_total']}
                    />
                  </SmallText>
                  <HeadingThree className="white">
                    {' '}
                    {numeral(this.state.stats[1].total).format('0,00.00')} €
                  </HeadingThree>
                </div>
              </div>
              <div className="row smaller-padding">
                <div className="col">
                  <SmallText className="green bolder">
                    <FormattedMessage
                      id="investor_dash_banner_circle_chart_waits_paid"
                      defaultMessage={dlt['investor_dash_banner_circle_chart_waits_paid']}
                    />
                  </SmallText>
                  <HeadingFour className="green">
                    {numeral(this.state.stats[1].paid).format('0,00.00')} €
                  </HeadingFour>
                </div>
              </div>
              <div className="row smaller-padding">
                <div className="col">
                  <SmallText className="chart-grey bolder">
                    <FormattedMessage
                      id="investor_dash_banner_circle_chart_from_medium_delay"
                      defaultMessage={dlt['investor_dash_banner_circle_chart_from_medium_delay']}
                    />
                  </SmallText>
                  <HeadingFour className="chart-grey">
                    {numeral(this.state.stats[1].delayed).format('0,00.00')} €
                  </HeadingFour>
                </div>
              </div>
              <div className="row smaller-padding">
                <div className="col">
                  <SmallText className="white bolder">
                    <FormattedMessage
                      id="investor_dash_banner_circle_chart_waits_till_end"
                      defaultMessage={dlt['investor_dash_banner_circle_chart_waits_till_end']}
                    />
                  </SmallText>
                  <HeadingFour className="white">
                    {numeral(this.state.stats[1].tillEnd).format('0,00.00')} €
                  </HeadingFour>
                </div>
              </div>
            </DataWrapSC>
          ) : (
            <DataWrapSC>
              <div className="row smaller-padding">
                <div className="col">
                  <SmallText className="dark-grey bolder">
                    <FormattedMessage
                      id="investor_dash_banner_circle_chart_value_total"
                      defaultMessage={dlt['investor_dash_banner_circle_chart_value_total']}
                    />
                  </SmallText>
                  <HeadingThree className="white">
                    {' '}
                    {numeral(this.state.stats[2].total).format('0,00.00')} €
                  </HeadingThree>
                </div>
              </div>
              <div className="row smaller-padding">
                <div className="col">
                  <SmallText className="green bolder">
                    <FormattedMessage
                      id="investor_dash_banner_circle_chart_waits_paid"
                      defaultMessage={dlt['investor_dash_banner_circle_chart_waits_paid']}
                    />
                  </SmallText>
                  <HeadingFour className="green">
                    {numeral(this.state.stats[2].paid).format('0,00.00')} €
                  </HeadingFour>
                </div>
              </div>
              <div className="row smaller-padding">
                <div className="col">
                  <SmallText className="red bolder">
                    <FormattedMessage
                      id="investor_dash_banner_circle_chart_from_high_delay"
                      defaultMessage={dlt['investor_dash_banner_circle_chart_from_high_delay']}
                    />
                  </SmallText>
                  <HeadingFour className="red">
                    {numeral(this.state.stats[2].delayed).format('0,00.00')} €
                  </HeadingFour>
                </div>
              </div>
              <div className="row smaller-padding">
                <div className="col">
                  <SmallText className="white bolder">
                    <FormattedMessage
                      id="investor_dash_banner_circle_chart_waits_till_end"
                      defaultMessage={dlt['investor_dash_banner_circle_chart_waits_till_end']}
                    />
                  </SmallText>
                  <HeadingFour className="white">
                    {numeral(this.state.stats[2].tillEnd).format('0,00.00')} €
                  </HeadingFour>
                </div>
              </div>
            </DataWrapSC>
          )}

          {this.state.selectedType === '' ? (
            <div className="legend">
              <div className="green">
                <span></span>
                <SmallText className="smaller green">
                  <FormattedMessage
                    id="investor_dash_banner_circle_chart_no_delay"
                    defaultMessage={dlt['investor_dash_banner_circle_chart_no_delay']}
                  />
                </SmallText>
              </div>
              <div className="grey">
                <span></span>
                <SmallText className="smaller chart-grey">
                  <FormattedMessage
                    id="investor_dash_banner_circle_chart_medium_delay"
                    defaultMessage={dlt['investor_dash_banner_circle_chart_medium_delay']}
                  />
                </SmallText>
              </div>
              <div className="red">
                <span></span>
                <SmallText className="smaller red">
                  <FormattedMessage
                    id="investor_dash_banner_circle_chart_high_delay"
                    defaultMessage={dlt['investor_dash_banner_circle_chart_high_delay']}
                  />
                </SmallText>
              </div>
            </div>
          ) : null}
        </ChartBottomSC>
      </InvestCircleChartSC>
    );
  }
}

export default InvestCircleChart;
